<template>
  <div class="not-found">
    <h1>Oops... Page Not found..</h1>
    <app-btn @click="$router.go(-1)">Voltar</app-btn>
  </div>
</template>
